import type { FreightShipmentSortColumn, OrderByDirection } from '@shipstation/client-common/types/freight-requests';
import type { FreightGridStatusCountsResponse } from '@shipstation/client-common/types/freight-responses';
import type { FreightStatusViewFilter } from '../../../pages/ltl-freight/components/freight-filter-bar/filters/options/status-view-map';
import type { AppliedFilter } from '../../../pages/ltl-freight/components/freight-filter-bar/map-freight-filters-to-api-params';

export const GET_FREIGHT_GRID_REQUEST = 'GET_FREIGHT_GRID_REQUEST';
export const getFreightGridRequest = (page?: number, pageSize?: number, statusFilter?: FreightStatusViewFilter | null) => ({
  type: GET_FREIGHT_GRID_REQUEST,
  page,
  pageSize,
  statusFilter,
});

export const GET_FREIGHT_GRID_SUCCESS = 'GET_FREIGHT_GRID_SUCCESS';
export const getFreightGridSuccess = (currentPageFulfillmentPlanIds: string[], page: number, pageSize: number, totalCount: number) => ({
  type: GET_FREIGHT_GRID_SUCCESS,
  currentPageFulfillmentPlanIds,
  page,
  pageSize,
  totalCount,
});

/**
 * Success for the Voided view, whose rows are freight shipments. Kept apart from
 * GET_FREIGHT_GRID_SUCCESS so shipment ids never land in currentPageFulfillmentPlanIds.
 */
export const GET_FREIGHT_SHIPMENT_GRID_SUCCESS = 'GET_FREIGHT_SHIPMENT_GRID_SUCCESS';
export const getFreightShipmentGridSuccess = (
  currentPageFreightShipmentIds: string[],
  page: number,
  pageSize: number,
  totalCount: number,
) => ({
  type: GET_FREIGHT_SHIPMENT_GRID_SUCCESS,
  currentPageFreightShipmentIds,
  page,
  pageSize,
  totalCount,
});

/**
 * Shared by both grid epics, so unlike the two successes it cannot be told apart by type alone — the flag
 * lets the reducer drop an error belonging to a view the user has already left.
 */
export const GET_FREIGHT_GRID_ERROR = 'GET_FREIGHT_GRID_ERROR';
export const getFreightGridError = (isFreightShipmentGrid: boolean) => ({
  type: GET_FREIGHT_GRID_ERROR,
  isFreightShipmentGrid,
});

export const SET_SELECTED_FREIGHT_FULFILLMENT_PLAN_IDS = 'SET_SELECTED_FREIGHT_FULFILLMENT_PLAN_IDS';
export const setSelectedFreightFulfillmentPlanIds = (selectedFulfillmentPlanIds: string[]) => ({
  type: SET_SELECTED_FREIGHT_FULFILLMENT_PLAN_IDS,
  selectedFulfillmentPlanIds,
});

export const SET_FREIGHT_GRID_FILTERS = 'SET_FREIGHT_GRID_FILTERS';
export const setFreightGridFilters = (appliedFilters: AppliedFilter[], filters: Record<string, unknown>) => ({
  type: SET_FREIGHT_GRID_FILTERS,
  appliedFilters,
  filters,
});

export const GET_FREIGHT_SEARCH_COUNTS = 'GET_FREIGHT_SEARCH_COUNTS';
export const getFreightSearchCounts = () => ({ type: GET_FREIGHT_SEARCH_COUNTS });

export const GET_FREIGHT_SEARCH_COUNTS_SUCCESS = 'GET_FREIGHT_SEARCH_COUNTS_SUCCESS';
export const getFreightSearchCountsSuccess = (counts: FreightGridStatusCountsResponse) => ({
  type: GET_FREIGHT_SEARCH_COUNTS_SUCCESS,
  counts,
});

export const GET_FREIGHT_SEARCH_COUNTS_ERROR = 'GET_FREIGHT_SEARCH_COUNTS_ERROR';
export const getFreightSearchCountsError = () => ({ type: GET_FREIGHT_SEARCH_COUNTS_ERROR });

export const SET_FREIGHT_SEARCH_TERM = 'SET_FREIGHT_SEARCH_TERM';
export const setFreightSearchTerm = (searchTerm: string) => ({
  type: SET_FREIGHT_SEARCH_TERM,
  searchTerm,
});

export const FREIGHT_SEARCH = 'FREIGHT_SEARCH';
export const freightSearch = (searchTerm: string) => ({
  type: FREIGHT_SEARCH,
  searchTerm,
});

export const CLEAR_FREIGHT_SEARCH = 'CLEAR_FREIGHT_SEARCH';
export const clearFreightSearch = () => ({
  type: CLEAR_FREIGHT_SEARCH,
});

export const SET_FREIGHT_SORT = 'SET_FREIGHT_SORT';
export const setFreightSort = (orderBy: FreightShipmentSortColumn | null, orderByDirection: OrderByDirection) => ({
  type: SET_FREIGHT_SORT,
  orderBy,
  orderByDirection,
});
